export default __webpack_public_path__ + "static-front/media/MinusIcon.91ba2349.svg";